import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '@shared/Interface/user';
import { EntityDataService } from '../../../api/entity/entity.data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService extends EntityDataService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private entityDataService: EntityDataService;
  constructor(httpClient: HttpClient, http: Http) {
    super(httpClient, http);
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(email: String, password: String) {
    return this.getUserEntity$(email)
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user) {
          // store user details in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
        return user;
      }));
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }
}
